import type * as React from "react";
import {
  Sidebar as SidebarUI,
  SidebarRail,
} from "@/core/components/ui/sidebar";
import { useAuth } from "@/core/components/auth/store/auth";
import { WosSidebarHeader } from "./wos-sidebar-header";
import { WosSidebarMenu } from "./wos-sidebar-menu";
import { WosSidebarFooter } from "./wos-sidebar-footer";
import { WosSidebarEntity } from "./wos-sidebar-entity";

export function WosSidebar({
  ...props
}: React.ComponentProps<typeof SidebarUI>) {
  const { userInfo } = useAuth();

  if (!userInfo || !userInfo.user) {
    return null;
  }

  return (
    <SidebarUI
      {...props}
      collapsible="icon"
      // Gaveta do mobile: mesma cor do cartão da sidebar no desktop.
      mobileClassName="bg-[color:var(--woba-color-background-default)]"
      // Figma (Shell 6051:2743): no desktop a sidebar é um cartão branco
      // (background-default) com cantos direitos de raio 24, afastado 24px do
      // topo e da base da viewport, como o cartão de conteúdo (py-6). O Sheet do mobile não recebe esta classe.
      className="border-none font-body md:py-6 [&>[data-sidebar=sidebar]]:overflow-hidden [&>[data-sidebar=sidebar]]:bg-[var(--woba-color-background-default)] md:[&>[data-sidebar=sidebar]]:rounded-r-3xl"
      data-testid="wos-sidebar"
    >
      <WosSidebarHeader />
      <WosSidebarEntity />
      <WosSidebarMenu />
      <WosSidebarFooter />
      <SidebarRail />
    </SidebarUI>
  );
}
